var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTrainings = function SvgIconTrainings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-trainings_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-trainings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "m9.104 9.354-1.13-1.13a.72.72 0 0 0-.26-.172.876.876 0 0 0-.588 0 .77.77 0 0 0-.5.749.77.77 0 0 0 .228.574l1.73 1.73c.147.152.32.228.516.228a.722.722 0 0 0 .525-.229l3.833-3.52c0-.208-.017-.41-.052-.604a.967.967 0 0 0-.281-.522.792.792 0 0 0-.567-.229.76.76 0 0 0-.558.23L9.104 9.353ZM1 17v-1.5h17.25c.212 0 .39.072.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219H1Zm2.5-2.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 2 13V4.5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h13c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06V13c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-13Zm0-1.5h13V4.5h-13V13Z"
  }))));
};
export default SvgIconTrainings;